module.exports = __webpack_public_path__ + "img/a-propos-prestations-2.ef7d497b.webp";